module.exports = __webpack_public_path__ + "img/generalmobile-gm8.91aa2db5.jpg";